<div #overlay class="overlay">
    <div class="content center-content">
        <div class="content-container" data-cy="vessel-folder-req-approval-approver-reject-confirmation-modal">
            <div class="padding-container">
                <div class="column-flex">
                    <div
                        class="form-label"
                        data-cy="vessel-folder-req-approval-approver-reject-confirmation-modal-header">
                        {{ 'reject.publish.dialog.title' | translate }}
                    </div>

                    <app-textarea-with-error
                        class="input-form"
                        [inputValue]="rejectReason"
                        [legend]="'reject.publish.dialog.form.legend'"
                        [propertyName]="'reason'"
                        [validatorFunction]="validatorFunction()"
                        (onInputUpdated)="rejectReason = $event"
                        [maxLength]="REJECTREASON_MAX_LENGTH"
                        [rows]="9"
                    ></app-textarea-with-error>
                </div>
            </div>
            <div class="buttons-container">
                <div
                    class="cancel button"
                    data-cy="vessel-folder-req-approval-approver-reject-confirmation-cancel-btn"
                    (click)="cancel()">
                    {{ 'reject.publish.dialog.button.cancel' | translate }}
                </div>
                <div
                    class="reject button"
                    data-cy="vessel-folder-req-approval-approver-reject-confirmation-reject-btn"
                    (click)="rejectPublish()"
                    [ngClass]="{ disabledButton: isButtonDisabled() }">
                    {{ 'reject.publish.dialog.button.reject' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
